import path from 'node:path';
import { componentGenerator } from '@wix/gena';
import { getEventsFolder } from '@wix/cli-app-definitions';

const EVENT_TEMPLATE = path.resolve(__dirname, '../templates/event');

export async function generateEvent(projectFolder: string, folderName: string) {
  const cwd = path.join(getEventsFolder(projectFolder), folderName);

  return await componentGenerator({
    template: EVENT_TEMPLATE,
    cwd,
    projectFolder,
  });
}
